import dayjs from "dayjs";
export const bluesethescope=(<svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
  <path d="M3.34782 5.53846C2.71361 5.53846 2.10537 5.29533 1.65692 4.86255C1.20846 4.42978 0.956521 3.84281 0.956521 3.23077V1.38462C0.956521 1.26221 1.00691 1.14481 1.0966 1.05826C1.18629 0.971703 1.30794 0.923077 1.43478 0.923077H1.91304C2.03989 0.923077 2.16153 0.874451 2.25122 0.787895C2.34092 0.70134 2.3913 0.583946 2.3913 0.461538C2.3913 0.339131 2.34092 0.221737 2.25122 0.135181C2.16153 0.0486262 2.03989 0 1.91304 0H1.43478C1.05425 0 0.689312 0.145879 0.420238 0.405544C0.151164 0.66521 0 1.01739 0 1.38462V3.23077C0.000614766 3.75219 0.132369 4.26567 0.383948 4.72711C0.635526 5.18856 0.999409 5.58418 1.44435 5.88C1.87226 6.24336 2.21923 6.68681 2.46422 7.18346C2.70921 7.68011 2.84712 8.21961 2.86956 8.76923C2.86956 9.62608 3.22228 10.4478 3.85012 11.0537C4.47796 11.6596 5.32949 12 6.21739 12C7.10529 12 7.95682 11.6596 8.58466 11.0537C9.2125 10.4478 9.56521 9.62608 9.56521 8.76923V8.24308C10.016 8.13074 10.409 7.86359 10.6703 7.49169C10.9316 7.11979 11.0434 6.66868 10.9847 6.22292C10.9261 5.77716 10.701 5.36735 10.3516 5.07031C10.0022 4.77327 9.55257 4.60939 9.08695 4.60939C8.62133 4.60939 8.17169 4.77327 7.82232 5.07031C7.47295 5.36735 7.24783 5.77716 7.18916 6.22292C7.13049 6.66868 7.24229 7.11979 7.50362 7.49169C7.76495 7.86359 8.15786 8.13074 8.60869 8.24308V8.76923C8.60869 9.38127 8.35675 9.96824 7.9083 10.401C7.45984 10.8338 6.8516 11.0769 6.21739 11.0769C5.58318 11.0769 4.97494 10.8338 4.52648 10.401C4.07803 9.96824 3.82609 9.38127 3.82609 8.76923C3.84974 8.21892 3.98914 7.67901 4.23579 7.18232C4.48245 6.68563 4.83121 6.24254 5.26087 5.88C5.70404 5.58315 6.06606 5.18708 6.31594 4.7257C6.56582 4.26432 6.6961 3.75137 6.69565 3.23077V1.38462C6.69565 1.01739 6.54449 0.66521 6.27541 0.405544C6.00634 0.145879 5.6414 0 5.26087 0H4.78261C4.65576 0 4.53412 0.0486262 4.44443 0.135181C4.35473 0.221737 4.30435 0.339131 4.30435 0.461538C4.30435 0.583946 4.35473 0.70134 4.44443 0.787895C4.53412 0.874451 4.65576 0.923077 4.78261 0.923077H5.26087C5.38771 0.923077 5.50936 0.971703 5.59905 1.05826C5.68874 1.14481 5.73913 1.26221 5.73913 1.38462V3.23077C5.73913 3.53382 5.67728 3.8339 5.5571 4.11388C5.43693 4.39387 5.26078 4.64826 5.03873 4.86255C4.81668 5.07684 4.55306 5.24683 4.26294 5.3628C3.97281 5.47877 3.66185 5.53846 3.34782 5.53846ZM9.08695 7.38462C8.83327 7.38462 8.58997 7.28736 8.41059 7.11425C8.23121 6.94114 8.13043 6.70635 8.13043 6.46154C8.13043 6.21672 8.23121 5.98194 8.41059 5.80882C8.58997 5.63571 8.83327 5.53846 9.08695 5.53846C9.34064 5.53846 9.58393 5.63571 9.76332 5.80882C9.9427 5.98194 10.0435 6.21672 10.0435 6.46154C10.0435 6.70635 9.9427 6.94114 9.76332 7.11425C9.58393 7.28736 9.34064 7.38462 9.08695 7.38462Z" fill="#1D2951"/>
</svg>)
export const cancelfrontdeskicon=
(
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="24"
  height="24"
  fill="none"
>

  <rect
    x="4"
    y="5"
    width="16"
    height="10"
    rx="2"
    stroke="white"
    stroke-width="2"
  />

  
  <path
    d="M2 17h20"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
  />

  <line
    x1="3"
    y1="3"
    x2="21"
    y2="21"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>)
export const cancelfrontdeskicondashboard=
(
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="24"
  height="24"
  fill="none"
>

  <rect
    x="4"
    y="5"
    width="16"
    height="10"
    rx="2"
    stroke="black"
    stroke-width="2"
  />

  
  <path
    d="M2 17h20"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
  />

  <line
    x1="3"
    y1="3"
    x2="21"
    y2="21"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>)
export const dobpcard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.66699 1.6665V4.99984"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.333 1.6665V4.99984"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.8333 3.3335H4.16667C3.24619 3.3335 2.5 4.07969 2.5 5.00016V16.6668C2.5 17.5873 3.24619 18.3335 4.16667 18.3335H15.8333C16.7538 18.3335 17.5 17.5873 17.5 16.6668V5.00016C17.5 4.07969 16.7538 3.3335 15.8333 3.3335Z"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.5 8.3335H17.5"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const mobileapp=<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M16 2H8C6.89543 2 6 2.89543 6 4V20C6 21.1046 6.89543 22 8 22H16C17.1046 22 18 21.1046 18 20V4C18 2.89543 17.1046 2 16 2Z" stroke="#202224" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.9502 18H12.0502" stroke="#202224" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
export const mobileicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.3332 14.0999V16.5999C18.3341 16.832 18.2866 17.0617 18.1936 17.2744C18.1006 17.487 17.9643 17.6779 17.7933 17.8348C17.6222 17.9917 17.4203 18.1112 17.2005 18.1855C16.9806 18.2599 16.7477 18.2875 16.5165 18.2666C13.9522 17.988 11.489 17.1117 9.32486 15.7083C7.31139 14.4288 5.60431 12.7217 4.32486 10.7083C2.91651 8.53426 2.04007 6.05908 1.76653 3.48325C1.7457 3.25281 1.77309 3.02055 1.84695 2.80127C1.9208 2.58199 2.03951 2.38049 2.1955 2.2096C2.3515 2.03871 2.54137 1.90218 2.75302 1.80869C2.96468 1.7152 3.19348 1.6668 3.42486 1.66658H5.92486C6.32928 1.6626 6.72136 1.80582 7.028 2.06953C7.33464 2.33324 7.53493 2.69946 7.59153 3.09992C7.69705 3.89997 7.89274 4.68552 8.17486 5.44158C8.28698 5.73985 8.31125 6.06401 8.24478 6.37565C8.17832 6.68729 8.02392 6.97334 7.79986 7.19992L6.74153 8.25825C7.92783 10.3445 9.65524 12.072 11.7415 13.2583L12.7999 12.1999C13.0264 11.9759 13.3125 11.8215 13.6241 11.755C13.9358 11.6885 14.2599 11.7128 14.5582 11.8249C15.3143 12.107 16.0998 12.3027 16.8999 12.4083C17.3047 12.4654 17.6744 12.6693 17.9386 12.9812C18.2029 13.2931 18.3433 13.6912 18.3332 14.0999Z"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const retrive=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M14.9894 8.39688L13.9894 3.65281C13.7963 2.61781 13.0525 2 12 2H4C3.475 2 3.03125 2.14656 2.68438 2.43563C2.3375 2.72469 2.11031 3.13281 2.01 3.65094L1.01 8.39688C1.00326 8.43083 0.999906 8.46538 1 8.5V12C1 12.5304 1.21072 13.0391 1.58579 13.4142C1.96086 13.7893 2.46957 14 3 14H13C13.5304 14 14.0391 13.7893 14.4142 13.4142C14.7893 13.0391 15 12.5304 15 12V8.5C14.9999 8.46536 14.9963 8.43081 14.9894 8.39688ZM2.98938 3.85313V3.84437C3.10031 3.26844 3.42094 3.00062 3.99844 3.00062H12C12.5816 3.00062 12.9022 3.26781 13.0084 3.84156C13.0084 3.84563 13.01 3.84969 13.0106 3.85375L13.8522 7.85C13.856 7.86821 13.8557 7.88704 13.8513 7.90511C13.8469 7.92319 13.8386 7.94006 13.8268 7.95449C13.8151 7.96893 13.8003 7.98056 13.7835 7.98854C13.7667 7.99652 13.7483 8.00065 13.7297 8.00062H10C9.86816 7.99996 9.74145 8.05165 9.6477 8.14435C9.55395 8.23704 9.50083 8.36316 9.5 8.495C9.5 8.89282 9.34197 9.27436 9.06066 9.55566C8.77936 9.83696 8.39783 9.995 8 9.995C7.60218 9.995 7.22065 9.83696 6.93934 9.55566C6.65804 9.27436 6.5 8.89282 6.5 8.495C6.49967 8.42967 6.48648 8.36504 6.46118 8.3048C6.43587 8.24457 6.39895 8.18991 6.35252 8.14394C6.30609 8.09798 6.25106 8.06161 6.19058 8.03691C6.13009 8.01221 6.06533 7.99967 6 8H2.27031C2.25171 8.00002 2.23334 7.99589 2.21653 7.98791C2.19973 7.97993 2.18492 7.9683 2.17318 7.95387C2.16144 7.93944 2.15308 7.92257 2.14869 7.90449C2.1443 7.88641 2.144 7.86758 2.14781 7.84937L2.98938 3.85313Z" fill="black"/>
</svg>
export const emailicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.667 3.3335H3.33366C2.41318 3.3335 1.66699 4.07969 1.66699 5.00016V15.0002C1.66699 15.9206 2.41318 16.6668 3.33366 16.6668H16.667C17.5875 16.6668 18.3337 15.9206 18.3337 15.0002V5.00016C18.3337 4.07969 17.5875 3.3335 16.667 3.3335Z"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3337 5.8335L10.8587 10.5835C10.6014 10.7447 10.3039 10.8302 10.0003 10.8302C9.69673 10.8302 9.39927 10.7447 9.14199 10.5835L1.66699 5.8335"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const locationicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.6663 8.33317C16.6663 13.3332 9.99967 18.3332 9.99967 18.3332C9.99967 18.3332 3.33301 13.3332 3.33301 8.33317C3.33301 6.56506 4.03539 4.86937 5.28563 3.61913C6.53587 2.36888 8.23156 1.6665 9.99967 1.6665C11.7678 1.6665 13.4635 2.36888 14.7137 3.61913C15.964 4.86937 16.6663 6.56506 16.6663 8.33317Z"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 10.8335C11.3807 10.8335 12.5 9.71421 12.5 8.3335C12.5 6.95278 11.3807 5.8335 10 5.8335C8.61929 5.8335 7.5 6.95278 7.5 8.3335C7.5 9.71421 8.61929 10.8335 10 10.8335Z"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const insuranceicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5 18.3332V3.33317C5 2.89114 5.17559 2.46722 5.48816 2.15466C5.80072 1.8421 6.22464 1.6665 6.66667 1.6665H13.3333C13.7754 1.6665 14.1993 1.8421 14.5118 2.15466C14.8244 2.46722 15 2.89114 15 3.33317V18.3332H5Z"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.00033 10H3.33366C2.89163 10 2.46771 10.1756 2.15515 10.4882C1.84259 10.8007 1.66699 11.2246 1.66699 11.6667V16.6667C1.66699 17.1087 1.84259 17.5326 2.15515 17.8452C2.46771 18.1577 2.89163 18.3333 3.33366 18.3333H5.00033"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 7.5H16.6667C17.1087 7.5 17.5326 7.6756 17.8452 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V16.6667C18.3333 17.1087 18.1577 17.5326 17.8452 17.8452C17.5326 18.1577 17.1087 18.3333 16.6667 18.3333H15"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33301 5H11.6663"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33301 8.3335H11.6663"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33301 11.6665H11.6663"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33301 15H11.6663"
      stroke="#9CA3AF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const clock = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      d="M7.8951 12.8333C11.1168 12.8333 13.7284 10.2217 13.7284 6.99999C13.7284 3.77833 11.1168 1.16666 7.8951 1.16666C4.67344 1.16666 2.06177 3.77833 2.06177 6.99999C2.06177 10.2217 4.67344 12.8333 7.8951 12.8333Z"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.89502 3.5V7L10.2284 8.16667"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const insurance = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 11 14"
    fill="none"
  >
    <path
      d="M10.3618 7.58334C10.3618 10.5 8.32011 11.9583 5.89344 12.8042C5.76637 12.8472 5.62834 12.8452 5.50261 12.7983C3.07011 11.9583 1.02844 10.5 1.02844 7.58334V3.50001C1.02844 3.3453 1.0899 3.19693 1.1993 3.08753C1.30869 2.97813 1.45707 2.91667 1.61178 2.91667C2.77844 2.91667 4.23678 2.21667 5.25178 1.33001C5.37536 1.22442 5.53257 1.16641 5.69511 1.16641C5.85765 1.16641 6.01486 1.22442 6.13844 1.33001C7.15928 2.22251 8.61178 2.91667 9.77844 2.91667C9.93315 2.91667 10.0815 2.97813 10.1909 3.08753C10.3003 3.19693 10.3618 3.3453 10.3618 3.50001V7.58334Z"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const dobb = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      d="M8.84501 1.16666H3.59501C3.28559 1.16666 2.98885 1.28957 2.77005 1.50837C2.55126 1.72716 2.42834 2.0239 2.42834 2.33332V11.6667C2.42834 11.9761 2.55126 12.2728 2.77005 12.4916C2.98885 12.7104 3.28559 12.8333 3.59501 12.8333H10.595C10.9044 12.8333 11.2012 12.7104 11.42 12.4916C11.6388 12.2728 11.7617 11.9761 11.7617 11.6667V4.08332L8.84501 1.16666Z"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.2616 1.16666V3.49999C8.2616 3.80941 8.38451 4.10616 8.60331 4.32495C8.8221 4.54374 9.11884 4.66666 9.42826 4.66666H11.7616"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.92826 5.25H4.7616"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.42826 7.58334H4.7616"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.42826 9.91666H4.7616"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const clocksmall = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
  >
    <path
      d="M5.75 10C8.16625 10 10.125 8.04125 10.125 5.625C10.125 3.20875 8.16625 1.25 5.75 1.25C3.33375 1.25 1.375 3.20875 1.375 5.625C1.375 8.04125 3.33375 10 5.75 10Z"
      stroke="#4A5565"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.75 3V5.625L7.5 6.5"
      stroke="#4A5565"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const proceesingblue = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
  >
    <path
      d="M5.38 9.875C7.79625 9.875 9.755 7.91625 9.755 5.5C9.755 3.08375 7.79625 1.125 5.38 1.125C2.96376 1.125 1.005 3.08375 1.005 5.5C1.005 7.91625 2.96376 9.875 5.38 9.875Z"
      stroke="#1447E6"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.38 2.875V5.5H7.34875"
      stroke="#1447E6"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const checkout = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
  >
    <path
      d="M9.6679 4.625C9.8677 5.60556 9.7253 6.62499 9.26445 7.51328C8.80361 8.40157 8.05216 9.10502 7.13543 9.50632C6.2187 9.90763 5.19211 9.98253 4.22684 9.71853C3.26157 9.45454 2.41598 8.86761 1.83108 8.05562C1.24618 7.24363 0.957323 6.25566 1.01268 5.25648C1.06805 4.25729 1.46428 3.30728 2.1353 2.56488C2.80633 1.82248 3.71159 1.33256 4.70011 1.17682C5.68864 1.02108 6.70067 1.20893 7.56746 1.70906"
      stroke="#007A55"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.0675 5.0625L5.38 6.375L9.755 2"
      stroke="#007A55"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const cancelled = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
  >
    <path
      d="M5.38 10.375C7.79625 10.375 9.755 8.41625 9.755 6C9.755 3.58375 7.79625 1.625 5.38 1.625C2.96376 1.625 1.005 3.58375 1.005 6C1.005 8.41625 2.96376 10.375 5.38 10.375Z"
      stroke="#C10007"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.6925 4.6875L4.0675 7.3125"
      stroke="#C10007"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.0675 4.6875L6.6925 7.3125"
      stroke="#C10007"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const syncbutton=<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22 24" fill="none">
  <path d="M18.4351 6.01875C17.2724 4.50832 15.6946 3.36955 13.8949 2.74175C12.0951 2.11394 10.1514 2.02434 8.30149 2.48389C6.4516 2.94345 4.77577 3.93224 3.47902 5.32928C2.18227 6.72633 1.32084 8.47106 1.00012 10.35M18.9164 1V6.5H13.4164M2.89487 17.9813C4.05727 19.4923 5.63499 20.6316 7.43491 21.2598C9.23482 21.8879 11.1788 21.9777 13.029 21.5181C14.8791 21.0585 16.5552 20.0694 17.8519 18.672C19.1486 17.2745 20.0097 15.5293 20.3299 13.65M2.415 23V17.5H7.915" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
export const syncbuttonsmall=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 22 24" fill="none">
  <path d="M18.4351 6.01875C17.2724 4.50832 15.6946 3.36955 13.8949 2.74175C12.0951 2.11394 10.1514 2.02434 8.30149 2.48389C6.4516 2.94345 4.77577 3.93224 3.47902 5.32928C2.18227 6.72633 1.32084 8.47106 1.00012 10.35M18.9164 1V6.5H13.4164M2.89487 17.9813C4.05727 19.4923 5.63499 20.6316 7.43491 21.2598C9.23482 21.8879 11.1788 21.9777 13.029 21.5181C14.8791 21.0585 16.5552 20.0694 17.8519 18.672C19.1486 17.2745 20.0097 15.5293 20.3299 13.65M2.415 23V17.5H7.915" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
export const noshow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
  >
    <path
      d="M5.38 10.375C7.79625 10.375 9.755 8.41625 9.755 6C9.755 3.58375 7.79625 1.625 5.38 1.625C2.96376 1.625 1.005 3.58375 1.005 6C1.005 8.41625 2.96376 10.375 5.38 10.375Z"
      stroke="#364153"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.38 4.25V6"
      stroke="#364153"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.38 7.75H5.38438"
      stroke="#364153"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const readyforcheckout = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
  >
    <path
      d="M5.38 9.875C7.79625 9.875 9.755 7.91625 9.755 5.5C9.755 3.08375 7.79625 1.125 5.38 1.125C2.96376 1.125 1.005 3.08375 1.005 5.5C1.005 7.91625 2.96376 9.875 5.38 9.875Z"
      stroke="#BB4D00"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.38 2.875V5.5H7.34875"
      stroke="#BB4D00"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const calenderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M5.30664 1.41666V3.75"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.97339 1.41666V3.75"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7233 2.58334H3.55668C2.91235 2.58334 2.39001 3.10567 2.39001 3.75V11.9167C2.39001 12.561 2.91235 13.0833 3.55668 13.0833H11.7233C12.3677 13.0833 12.89 12.561 12.89 11.9167V3.75C12.89 3.10567 12.3677 2.58334 11.7233 2.58334Z"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.39001 6.08334H12.89"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const paymentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M11.9119 3.16666H2.57853C1.9342 3.16666 1.41187 3.689 1.41187 4.33333V10.1667C1.41187 10.811 1.9342 11.3333 2.57853 11.3333H11.9119C12.5562 11.3333 13.0785 10.811 13.0785 10.1667V4.33333C13.0785 3.689 12.5562 3.16666 11.9119 3.16666Z"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.41187 6.08334H13.0785"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const editicongreen = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M7.75 12.1667H13"
      stroke="#009966"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.3027 2.61286C10.5349 2.38064 10.8499 2.25018 11.1783 2.25018C11.5067 2.25018 11.8216 2.38064 12.0539 2.61286C12.2861 2.84508 12.4165 3.16004 12.4165 3.48845C12.4165 3.81685 12.2861 4.13181 12.0539 4.36403L5.04803 11.3704C4.90925 11.5092 4.73771 11.6107 4.54928 11.6656L2.87394 12.1544C2.82375 12.1691 2.77054 12.17 2.71989 12.157C2.66924 12.144 2.62301 12.1177 2.58604 12.0807C2.54907 12.0437 2.52271 11.9975 2.50974 11.9468C2.49676 11.8962 2.49764 11.843 2.51228 11.7928L3.00111 10.1174C3.05607 9.92922 3.15759 9.75789 3.29628 9.61928L10.3027 2.61286Z"
      stroke="#009966"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const humangrey = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M11.0833 12.25V11.0833C11.0833 10.4645 10.8375 9.871 10.3999 9.43342C9.96229 8.99583 9.3688 8.75 8.74996 8.75H5.24996C4.63112 8.75 4.03763 8.99583 3.60004 9.43342C3.16246 9.871 2.91663 10.4645 2.91663 11.0833V12.25"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.99996 6.41667C8.28862 6.41667 9.33329 5.372 9.33329 4.08333C9.33329 2.79467 8.28862 1.75 6.99996 1.75C5.71129 1.75 4.66663 2.79467 4.66663 4.08333C4.66663 5.372 5.71129 6.41667 6.99996 6.41667Z"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const sethescope = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M6.13245 1.42505V2.54028"
      stroke="#6A7282"
      stroke-width="1.115"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.78748 1.42505V2.54028"
      stroke="#6A7282"
      stroke-width="1.115"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.78749 1.98254H2.22999C1.93427 1.98254 1.65067 2.10002 1.44157 2.30912C1.23246 2.51822 1.11499 2.80183 1.11499 3.09754V5.32754C1.11499 6.21469 1.46741 7.06551 2.09472 7.69282C2.72203 8.32012 3.57284 8.67254 4.45999 8.67254C5.34714 8.67254 6.19795 8.32012 6.82526 7.69282C7.45257 7.06551 7.80499 6.21469 7.80499 5.32754V3.09754C7.80499 2.80183 7.68752 2.51822 7.47841 2.30912C7.26931 2.10002 6.98571 1.98254 6.68999 1.98254H6.13249"
      stroke="#6A7282"
      stroke-width="1.115"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.45996 8.6725C4.45996 9.55965 4.81238 10.4105 5.43969 11.0378C6.067 11.6651 6.91781 12.0175 7.80496 12.0175C8.69211 12.0175 9.54292 11.6651 10.1702 11.0378C10.7975 10.4105 11.15 9.55965 11.15 8.6725V7"
      stroke="#6A7282"
      stroke-width="1.115"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.1503 7.00049C11.7662 7.00049 12.2655 6.50118 12.2655 5.88525C12.2655 5.26933 11.7662 4.77002 11.1503 4.77002C10.5343 4.77002 10.035 5.26933 10.035 5.88525C10.035 6.50118 10.5343 7.00049 11.1503 7.00049Z"
      stroke="#6A7282"
      stroke-width="1.115"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const analysis = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M12.8333 6.99996H11.3866C11.1317 6.99941 10.8836 7.08239 10.6803 7.23619C10.477 7.38999 10.3296 7.60616 10.2608 7.85163L8.88996 12.7283C8.88112 12.7586 8.8627 12.7852 8.83746 12.8041C8.81222 12.8231 8.78151 12.8333 8.74996 12.8333C8.71841 12.8333 8.6877 12.8231 8.66246 12.8041C8.63722 12.7852 8.61879 12.7586 8.60996 12.7283L5.38996 1.27163C5.38112 1.24133 5.3627 1.21473 5.33746 1.19579C5.31222 1.17686 5.28151 1.16663 5.24996 1.16663C5.21841 1.16663 5.1877 1.17686 5.16246 1.19579C5.13722 1.21473 5.11879 1.24133 5.10996 1.27163L3.73913 6.14829C3.67056 6.3928 3.5241 6.60826 3.32196 6.76197C3.11983 6.91567 2.87306 6.99923 2.61913 6.99996H1.16663"
      stroke="#6A7282"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const orders = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      d="M3.51001 11H8.17668"
      stroke="#0A0A0A"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.76001 13.3334H12.26"
      stroke="#0A0A0A"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.17672 13.3333C9.25968 13.3333 10.2983 12.9031 11.0641 12.1373C11.8298 11.3715 12.2601 10.3329 12.2601 9.24996C12.2601 8.16699 11.8298 7.12838 11.0641 6.36261C10.2983 5.59683 9.25968 5.16663 8.17672 5.16663H7.59338"
      stroke="#0A0A0A"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.26001 8.66663H6.42668"
      stroke="#0A0A0A"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.26005 7.5C4.95063 7.5 4.65388 7.37708 4.43509 7.15829C4.2163 6.9395 4.09338 6.64275 4.09338 6.33333V4H7.59338V6.33333C7.59338 6.64275 7.47047 6.9395 7.25167 7.15829C7.03288 7.37708 6.73614 7.5 6.42672 7.5H5.26005Z"
      stroke="#0A0A0A"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.00997 3.99996V2.24996C7.00997 2.09525 6.94851 1.94688 6.83911 1.83748C6.72972 1.72808 6.58135 1.66663 6.42664 1.66663H5.25997C5.10526 1.66663 4.95689 1.72808 4.84749 1.83748C4.73809 1.94688 4.67664 2.09525 4.67664 2.24996V3.99996"
      stroke="#0A0A0A"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const todayorder = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M15.8966 7.79163C16.2296 9.42591 15.9923 11.125 15.2242 12.6054C14.4561 14.0859 13.2037 15.2583 11.6758 15.9272C10.148 16.596 8.43696 16.7208 6.82818 16.2809C5.2194 15.8409 3.81008 14.8626 2.83524 13.5093C1.86041 12.156 1.37899 10.5094 1.47126 8.8441C1.56353 7.17879 2.22391 5.59544 3.34229 4.35811C4.46066 3.12077 5.96942 2.30423 7.61697 2.04467C9.26451 1.7851 10.9512 2.09819 12.3959 2.93173"
      stroke="#6A7282"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.5625 8.52079L8.75 10.7083L16.0417 3.41663"
      stroke="#6A7282"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const noteedit = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M8.75 15.0834H15.3125"
      stroke="#6A7282"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.9408 3.14109C12.2311 2.85082 12.6248 2.68774 13.0353 2.68774C13.4458 2.68774 13.8395 2.85082 14.1298 3.14109C14.4201 3.43137 14.5831 3.82506 14.5831 4.23557C14.5831 4.64608 14.4201 5.03978 14.1298 5.33005L5.3725 14.0881C5.19903 14.2615 4.9846 14.3884 4.74907 14.457L2.6549 15.0681C2.59216 15.0864 2.52565 15.0875 2.46233 15.0712C2.39902 15.055 2.34123 15.0221 2.29502 14.9759C2.2488 14.9297 2.21586 14.8719 2.19964 14.8086C2.18342 14.7452 2.18452 14.6787 2.20282 14.616L2.81386 12.5218C2.88256 12.2865 3.00945 12.0724 3.18282 11.8991L11.9408 3.14109Z"
      stroke="#6A7282"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const chatIcon = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.80437 9.27083H12.2033C12.3912 9.27083 12.5713 9.1962 12.7042 9.06336C12.837 8.93052 12.9116 8.75036 12.9116 8.5625V2.89583C12.9116 2.70797 12.837 2.5278 12.7042 2.39496C12.5713 2.26212 12.3912 2.18749 12.2033 2.18749H2.28662C2.09876 2.18749 1.91859 2.26212 1.78575 2.39496C1.65292 2.5278 1.57829 2.70797 1.57829 2.89583V8.5625C1.57829 8.75036 1.65292 8.93052 1.78575 9.06336C1.91859 9.1962 2.09876 9.27083 2.28662 9.27083C2.47448 9.27083 2.65465 9.34546 2.78749 9.4783C2.92033 9.61113 2.99495 9.7913 2.99495 9.97916V12.1134L6.80437 9.27083ZM2.28662 0.770828H12.2033C12.7669 0.770828 13.3074 0.994712 13.7059 1.39323C14.1044 1.79174 14.3283 2.33224 14.3283 2.89583V8.5625C14.3283 9.12608 14.1044 9.66658 13.7059 10.0651C13.3074 10.4636 12.7669 10.6875 12.2033 10.6875H7.2747L2.7102 14.0932C2.60487 14.1718 2.47974 14.2195 2.34882 14.231C2.2179 14.2426 2.08636 14.2175 1.96889 14.1585C1.85143 14.0996 1.75269 14.0091 1.6837 13.8972C1.61472 13.7854 1.57822 13.6565 1.57829 13.5251V10.6875C1.20256 10.6875 0.84223 10.5382 0.576553 10.2726C0.310877 10.0069 0.161621 9.64655 0.161621 9.27083V2.89583C0.161621 2.33224 0.385504 1.79174 0.784019 1.39323C1.18253 0.994712 1.72304 0.770828 2.28662 0.770828Z"
      fill="currentColor"
    />
  </svg>
);

export const shareIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6839_5775)">
      <path
        d="M10.2141 14.9573C10.2395 15.0205 10.2835 15.0743 10.3403 15.1117C10.3971 15.1491 10.464 15.1682 10.532 15.1664C10.6 15.1647 10.6659 15.1422 10.7207 15.1019C10.7755 15.0617 10.8167 15.0057 10.8388 14.9413L15.1721 2.27466C15.1935 2.21559 15.1975 2.15167 15.1839 2.09037C15.1702 2.02907 15.1394 1.97293 15.095 1.92852C15.0505 1.8841 14.9944 1.85326 14.9331 1.83959C14.8718 1.82592 14.8079 1.82999 14.7488 1.85133L2.08214 6.18466C2.0178 6.20673 1.96175 6.24794 1.92152 6.30278C1.88128 6.35761 1.85878 6.42344 1.85704 6.49144C1.8553 6.55943 1.8744 6.62632 1.91178 6.68315C1.94915 6.73997 2.00302 6.784 2.06614 6.80933L7.3528 8.92933C7.51993 8.99624 7.67177 9.0963 7.79918 9.22348C7.92659 9.35066 8.02692 9.50233 8.09414 9.66933L10.2141 14.9573Z"
        stroke="#9CA3AF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0926 1.93134L7.79932 9.224"
        stroke="#9CA3AF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6839_5775">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.523438 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const closeIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.4998 13.2408L17.3495 20.0905C17.713 20.4539 18.206 20.6581 18.72 20.6581C19.234 20.6581 19.727 20.4539 20.0904 20.0905C20.4539 19.727 20.6581 19.234 20.6581 18.72C20.6581 18.206 20.4539 17.713 20.0904 17.3495L13.2381 10.4998L20.0891 3.65013C20.269 3.47016 20.4117 3.25652 20.509 3.02141C20.6064 2.78629 20.6564 2.53432 20.6564 2.27986C20.6563 2.0254 20.6061 1.77345 20.5087 1.53838C20.4113 1.30332 20.2685 1.08974 20.0885 0.909858C19.9085 0.729972 19.6949 0.587295 19.4598 0.489973C19.2247 0.392652 18.9727 0.342592 18.7182 0.342652C18.4638 0.342712 18.2118 0.392891 17.9768 0.490323C17.7417 0.587755 17.5281 0.730533 17.3482 0.910504L10.4998 7.76021L3.65011 0.910504C3.47146 0.725371 3.25774 0.577669 3.02141 0.476016C2.78507 0.374364 2.53086 0.320797 2.2736 0.318441C2.01634 0.316085 1.76119 0.364987 1.52304 0.462294C1.28488 0.559601 1.06849 0.703364 0.886486 0.885194C0.704484 1.06702 0.560517 1.28328 0.462985 1.52135C0.365454 1.75941 0.316311 2.01452 0.318425 2.27178C0.320538 2.52904 0.373865 2.7833 0.475295 3.01973C0.576724 3.25616 0.724224 3.47002 0.909189 3.64884L7.76148 10.4998L0.910481 17.3508C0.725517 17.5297 0.578016 17.7435 0.476587 17.9799C0.375157 18.2164 0.32183 18.4706 0.319716 18.7279C0.317603 18.9852 0.366746 19.2403 0.464277 19.4783C0.561809 19.7164 0.705775 19.9326 0.887778 20.1145C1.06978 20.2963 1.28617 20.4401 1.52433 20.5374C1.76248 20.6347 2.01764 20.6836 2.27489 20.6812C2.53215 20.6789 2.78636 20.6253 3.0227 20.5237C3.25903 20.422 3.47276 20.2743 3.6514 20.0892L10.4998 13.2408Z"
      fill="#C7C7CB"
    />
  </svg>
);

export const iCardIcon = (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.37012 7.08334C1.37012 4.41221 1.37012 3.0763 2.20028 2.24684C3.03045 1.41738 4.36566 1.41667 7.03678 1.41667H8.45345C11.1246 1.41667 12.4605 1.41667 13.2899 2.24684C14.1194 3.07701 14.1201 4.41221 14.1201 7.08334V9.91667C14.1201 12.5878 14.1201 13.9237 13.2899 14.7532C12.4598 15.5826 11.1246 15.5833 8.45345 15.5833H7.03678C4.36566 15.5833 3.02974 15.5833 2.20028 14.7532C1.37083 13.923 1.37012 12.5878 1.37012 9.91667V7.08334Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M4.91211 7.08334H10.5788M4.91211 9.91668H8.45378"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);

export const documentIcon = (
  <svg
    width="17"
    height="21"
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00268 0.642853C1.47982 0.642853 0.978383 0.850556 0.608668 1.22027C0.238954 1.58999 0.03125 2.09143 0.03125 2.61428V18.3857C0.03125 18.9086 0.238954 19.41 0.608668 19.7797C0.978383 20.1494 1.47982 20.3571 2.00268 20.3571H14.4884C15.0112 20.3571 15.5127 20.1494 15.8824 19.7797C16.2521 19.41 16.4598 18.9086 16.4598 18.3857V8.5105C16.4598 7.91167 16.2216 7.3375 15.7986 6.91364L10.1053 1.22032C9.73555 0.850597 9.23413 0.642877 8.71129 0.642853H2.00268ZM1.26339 2.61428C1.26339 2.41821 1.34128 2.23017 1.47992 2.09153C1.61857 1.95288 1.80661 1.875 2.00268 1.875H8.24554V7.21428C8.24554 7.64999 8.41862 8.06786 8.72672 8.37596C9.03481 8.68405 9.45268 8.85714 9.88839 8.85714H15.2277V18.3857C15.2277 18.5818 15.1498 18.7698 15.0111 18.9085C14.8725 19.0471 14.6845 19.125 14.4884 19.125H2.00268C1.80661 19.125 1.61857 19.0471 1.47992 18.9085C1.34128 18.7698 1.26339 18.5818 1.26339 18.3857V2.61428ZM14.7677 7.625H9.88839C9.77946 7.625 9.675 7.58172 9.59797 7.5047C9.52095 7.42768 9.47768 7.32321 9.47768 7.21428V2.335L14.7677 7.625Z"
      fill="currentColor"
    />
  </svg>
);

export const uploadIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9062 3V13"
      stroke="#166534"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.0726 7.16667L10.9059 3L6.73926 7.16667"
      stroke="#166534"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.4062 13V16.3333C18.4062 16.7754 18.2307 17.1993 17.9181 17.5118C17.6055 17.8244 17.1816 18 16.7396 18H5.07292C4.63089 18 4.20697 17.8244 3.89441 17.5118C3.58184 17.1993 3.40625 16.7754 3.40625 16.3333V13"
      stroke="#166534"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const eyeIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7040_7665)">
      <path
        d="M1.5778 8.732C1.52224 8.58232 1.52224 8.41768 1.5778 8.268C2.11894 6.9559 3.03748 5.83403 4.21698 5.0446C5.39649 4.25517 6.78383 3.83374 8.20314 3.83374C9.62244 3.83374 11.0098 4.25517 12.1893 5.0446C13.3688 5.83403 14.2873 6.9559 14.8285 8.268C14.884 8.41768 14.884 8.58232 14.8285 8.732C14.2873 10.0441 13.3688 11.166 12.1893 11.9554C11.0098 12.7448 9.62244 13.1663 8.20314 13.1663C6.78383 13.1663 5.39649 12.7448 4.21698 11.9554C3.03748 11.166 2.11894 10.0441 1.5778 8.732Z"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.20312 10.5C9.30769 10.5 10.2031 9.60457 10.2031 8.5C10.2031 7.39543 9.30769 6.5 8.20312 6.5C7.09856 6.5 6.20312 7.39543 6.20312 8.5C6.20312 9.60457 7.09856 10.5 8.20312 10.5Z"
        stroke="#15803D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7040_7665">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.203125 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const deleteIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7040_7670)">
      <path
        d="M2.33594 4.5H14.3359"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.0023 4.5V13.8333C13.0023 14.5 12.3356 15.1667 11.6689 15.1667H5.00228C4.33561 15.1667 3.66895 14.5 3.66895 13.8333V4.5"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.66895 4.5V3.16667C5.66895 2.5 6.33561 1.83333 7.00228 1.83333H9.66895C10.3356 1.83333 11.0023 2.5 11.0023 3.16667V4.5"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.00293 7.83333V11.8333"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.66895 7.83333V11.8333"
        stroke="#B91C1C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7040_7670">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.335938 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const filterIcon = (
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.4574 1H2.54025C2.2444 0.999743 1.95475 1.08607 1.70598 1.24866C1.45721 1.41124 1.25987 1.64318 1.13759 1.91671C1.01532 2.19023 0.973285 2.49375 1.01653 2.7909C1.05978 3.08806 1.18647 3.36626 1.38144 3.59219L9.54087 13.0578C9.78627 13.3429 9.92135 13.7088 9.92098 14.0875V21.7031C9.92098 21.8244 9.9488 21.944 10.0022 22.0525C10.0556 22.161 10.1332 22.2554 10.2288 22.3281L14.8456 25.8437C14.9599 25.9308 15.0958 25.9838 15.2382 25.9968C15.3805 26.0099 15.5236 25.9824 15.6514 25.9175C15.7792 25.8526 15.8867 25.7529 15.9618 25.6295C16.0369 25.5061 16.0767 25.3638 16.0767 25.2187V14.0875C16.0764 13.7088 16.2114 13.3429 16.4568 13.0578L24.6163 3.59063C25.4873 2.58125 24.7794 1 23.4574 1Z"
      stroke="#1D2951"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export const downArrowIcon = (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.16992 1L5.16992 5L9.16992 1"
      stroke="#09090B"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const successIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66536 7.83317C6.50631 7.83317 7.9987 6.34079 7.9987 4.49984C7.9987 2.65889 6.50631 1.1665 4.66536 1.1665C2.82442 1.1665 1.33203 2.65889 1.33203 4.49984C1.33203 6.34079 2.82442 7.83317 4.66536 7.83317Z"
      stroke="#15803D"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66504 4.50016L4.33171 5.16683L5.66504 3.8335"
      stroke="#15803D"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const createdIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7247_2203)">
      <path
        d="M4.00033 7.33317C5.84127 7.33317 7.33366 5.84079 7.33366 3.99984C7.33366 2.15889 5.84127 0.666504 4.00033 0.666504C2.15938 0.666504 0.666992 2.15889 0.666992 3.99984C0.666992 5.84079 2.15938 7.33317 4.00033 7.33317Z"
        stroke="#1D4ED8"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 4.00016L3.66667 4.66683L5 3.3335"
        stroke="#1D4ED8"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7247_2203">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const noteIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66504 5C7.66504 5.17681 7.5948 5.34638 7.46978 5.4714C7.34475 5.59643 7.17518 5.66667 6.99837 5.66667H2.99837L1.66504 7V1.66667C1.66504 1.48986 1.73528 1.32029 1.8603 1.19526C1.98533 1.07024 2.15489 1 2.33171 1H6.99837C7.17518 1 7.34475 1.07024 7.46978 1.19526C7.5948 1.32029 7.66504 1.48986 7.66504 1.66667V5Z"
      stroke="#2563EB"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const fileIcon = (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.41829 16.9167H9.58496V13.4167H13.085V12.25H9.58496V8.75H8.41829V12.25H4.91829V13.4167H8.41829V16.9167ZM0.834961 21V0H11.9183L17.1683 5.25V21H0.834961ZM11.335 5.83333H16.0016L11.335 1.16667V5.83333Z"
      fill="#1D2951"
      fill-opacity="0.65"
    />
  </svg>
);

export const crossIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4L12 12M12 4L4 12"
      stroke="#DC2626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const refreshinrefils = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M1.75 7C1.75 5.60761 2.30312 4.27226 3.28769 3.28769C4.27226 2.30312 5.60761 1.75 7 1.75C8.46769 1.75552 9.87643 2.32821 10.9317 3.34833L12.25 4.66667"
      stroke="#374151"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2499 1.75V4.66667H9.33325"
      stroke="#374151"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.25 7C12.25 8.39239 11.6969 9.72774 10.7123 10.7123C9.72774 11.6969 8.39239 12.25 7 12.25C5.53231 12.2445 4.12357 11.6718 3.06833 10.6517L1.75 9.33333"
      stroke="#374151"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66667 9.3335H1.75V12.2502"
      stroke="#374151"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const refreshIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 7C1.75 5.60761 2.30312 4.27226 3.28769 3.28769C4.27226 2.30312 5.60761 1.75 7 1.75C8.46769 1.75552 9.87643 2.32821 10.9317 3.34833L12.25 4.66667"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2499 1.75V4.66667H9.33325"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.25 7C12.25 8.39239 11.6969 9.72774 10.7123 10.7123C9.72774 11.6969 8.39239 12.25 7 12.25C5.53231 12.2445 4.12357 11.6718 3.06833 10.6517L1.75 9.33333"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66667 9.3335H1.75V12.2502"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const plusIcon = (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.41675 7H11.5834"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 2.9165V11.0832"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const correctIcon = (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.86224 3.21094L4.26849 7.80469L2.18042 5.71662"
      stroke="white"
      stroke-width="0.835227"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PrescriptionIcon = (
  <svg
    width="42"
    height="43"
    viewBox="0 0 42 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.75"
      width="42"
      height="42"
      rx="12.75"
      fill="white"
      fill-opacity="0.2"
    />
    <path
      d="M19.6874 29.1874L28.4374 20.4374C28.8462 20.0367 29.1716 19.5589 29.3947 19.0317C29.6178 18.5045 29.7341 17.9383 29.737 17.3658C29.7399 16.7934 29.6293 16.226 29.4115 15.6966C29.1938 15.1671 28.8733 14.6861 28.4685 14.2813C28.0637 13.8765 27.5826 13.556 27.0532 13.3382C26.5238 13.1205 25.9564 13.0099 25.3839 13.0128C24.8115 13.0156 24.2453 13.132 23.7181 13.3551C23.1908 13.5781 22.7131 13.9035 22.3124 14.3124L13.5624 23.0624C13.1535 23.4631 12.8281 23.9408 12.6051 24.4681C12.382 24.9953 12.2656 25.5615 12.2628 26.1339C12.2599 26.7064 12.3705 27.2738 12.5882 27.8032C12.806 28.3326 13.1265 28.8137 13.5313 29.2185C13.9361 29.6233 14.4171 29.9438 14.9466 30.1615C15.476 30.3793 16.0434 30.4899 16.6158 30.487C17.1883 30.4841 17.7545 30.3678 18.2817 30.1447C18.8089 29.9216 19.2867 29.5962 19.6874 29.1874Z"
      stroke="white"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.9375 18.6875L24.0625 24.8125"
      stroke="white"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const alertIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9017_12194)">
      <path
        d="M7.99967 14.6668C11.6816 14.6668 14.6663 11.6821 14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335C4.31778 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668Z"
        stroke="#E17100"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 5.3335V8.00016"
        stroke="#E17100"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 10.6665H8.00667"
        stroke="#E17100"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9017_12194">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const searchIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7501 15.7501L12.4951 12.4951"
      stroke="#9CA3AF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
      stroke="#9CA3AF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const COMPLETEDIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0.25C4.62391 0.25 0.25 4.62391 0.25 10C0.25 15.3761 4.62391 19.75 10 19.75C15.3761 19.75 19.75 15.3761 19.75 10C19.75 4.62391 15.3761 0.25 10 0.25ZM15.0742 6.73234L8.77422 14.2323C8.70511 14.3147 8.61912 14.3812 8.52207 14.4273C8.42502 14.4735 8.31918 14.4983 8.21172 14.5H8.19906C8.09394 14.5 7.99 14.4778 7.89398 14.435C7.79797 14.3922 7.71202 14.3297 7.64172 14.2516L4.94172 11.2516C4.87315 11.1788 4.81981 11.0931 4.78483 10.9995C4.74986 10.9059 4.73395 10.8062 4.73805 10.7063C4.74215 10.6064 4.76617 10.5084 4.8087 10.4179C4.85124 10.3275 4.91142 10.2464 4.98572 10.1796C5.06002 10.1127 5.14694 10.0614 5.24136 10.0286C5.33579 9.99578 5.43581 9.98219 5.53556 9.98861C5.63531 9.99502 5.73277 10.0213 5.82222 10.0659C5.91166 10.1106 5.99128 10.1726 6.05641 10.2484L8.17938 12.6072L13.9258 5.76766C14.0547 5.61863 14.237 5.52631 14.4335 5.51066C14.6299 5.49501 14.8246 5.55728 14.9754 5.68402C15.1263 5.81075 15.2212 5.99176 15.2397 6.18793C15.2582 6.3841 15.1988 6.57966 15.0742 6.73234Z"
      fill="#16A34A"
    />
  </svg>
);

export const CROSSIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.4 13.308L9 9.708L12.6 13.308L13.308 12.6L9.708 9L13.308 5.4L12.6 4.692L9 8.292L5.4 4.692L4.692 5.4L8.292 9L4.692 12.6L5.4 13.308ZM9.003 18C7.759 18 6.589 17.764 5.493 17.292C4.39767 16.8193 3.44467 16.178 2.634 15.368C1.82333 14.558 1.18167 13.606 0.709 12.512C0.236333 11.418 0 10.2483 0 9.003C0 7.75767 0.236333 6.58767 0.709 5.493C1.181 4.39767 1.82133 3.44467 2.63 2.634C3.43867 1.82333 4.391 1.18167 5.487 0.709C6.583 0.236333 7.753 0 8.997 0C10.241 0 11.411 0.236333 12.507 0.709C13.6023 1.181 14.5553 1.82167 15.366 2.631C16.1767 3.44033 16.8183 4.39267 17.291 5.488C17.7637 6.58333 18 7.753 18 8.997C18 10.241 17.764 11.411 17.292 12.507C16.82 13.603 16.1787 14.556 15.368 15.366C14.5573 16.176 13.6053 16.8177 12.512 17.291C11.4187 17.7643 10.249 18.0007 9.003 18Z"
      fill="#EF4444"
    />
  </svg>
);
export const vitalsicon=<svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12"    fill="currentColor">
  <path d="M6 12C5.7625 12 5.55 11.9313 5.3625 11.7938C5.175 11.6562 5.0375 11.4812 4.95 11.2687L3.225 6.75H0.750003C0.537503 6.75 0.359503 6.678 0.216003 6.534C0.0725026 6.39 0.000502586 6.212 2.58621e-06 6C-0.000497414 5.788 0.0715026 5.61 0.216003 5.466C0.360503 5.322 0.538503 5.25 0.750003 5.25H3.75C3.9125 5.25 4.05325 5.29375 4.17225 5.38125C4.29125 5.46875 4.38175 5.5875 4.44375 5.7375L6 9.825L9.45 0.73125C9.5375 0.51875 9.675 0.34375 9.8625 0.20625C10.05 0.0687501 10.2625 0 10.5 0C10.7375 0 10.95 0.0687501 11.1375 0.20625C11.325 0.34375 11.4625 0.51875 11.55 0.73125L13.275 5.25H15.75C15.9625 5.25 16.1408 5.322 16.2848 5.466C16.4288 5.61 16.5005 5.788 16.5 6C16.4995 6.212 16.4275 6.39025 16.284 6.53475C16.1405 6.67925 15.9625 6.751 15.75 6.75H12.75C12.5875 6.75 12.447 6.70625 12.3285 6.61875C12.21 6.53125 12.1193 6.4125 12.0563 6.2625L10.5 2.175L7.05 11.2687C6.9625 11.4812 6.825 11.6562 6.6375 11.7938C6.45 11.9313 6.2375 12 6 12Z" />
</svg>

export const vitalsiconbig = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="14"
    viewBox="0 0 17 12"
    fill="none"
  >
    <path
      d="M6 12C5.7625 12 5.55 11.9313 5.3625 11.7938C5.175 11.6562 5.0375 11.4812 4.95 11.2687L3.225 6.75H0.750003C0.537503 6.75 0.359503 6.678 0.216003 6.534C0.0725026 6.39 0.000502586 6.212 2.58621e-06 6C-0.000497414 5.788 0.0715026 5.61 0.216003 5.466C0.360503 5.322 0.538503 5.25 0.750003 5.25H3.75C3.9125 5.25 4.05325 5.29375 4.17225 5.38125C4.29125 5.46875 4.38175 5.5875 4.44375 5.7375L6 9.825L9.45 0.73125C9.5375 0.51875 9.675 0.34375 9.8625 0.20625C10.05 0.0687501 10.2625 0 10.5 0C10.7375 0 10.95 0.0687501 11.1375 0.20625C11.325 0.34375 11.4625 0.51875 11.55 0.73125L13.275 5.25H15.75C15.9625 5.25 16.1408 5.322 16.2848 5.466C16.4288 5.61 16.5005 5.788 16.5 6C16.4995 6.212 16.4275 6.39025 16.284 6.53475C16.1405 6.67925 15.9625 6.751 15.75 6.75H12.75C12.5875 6.75 12.447 6.70625 12.3285 6.61875C12.21 6.53125 12.1193 6.4125 12.0563 6.2625L10.5 2.175L7.05 11.2687C6.9625 11.4812 6.825 11.6562 6.6375 11.7938C6.45 11.9313 6.2375 12 6 12Z"
      fill="currentColor"
    />
  </svg>
);
export const Intakeicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="18"
    viewBox="0 0 12 16"
    fill="none"
  >
    <path
      d="M8 1.29167H10.25C10.4489 1.29167 10.6397 1.37507 10.7803 1.52354C10.921 1.67201 11 1.87337 11 2.08333V13.9583C11 14.1683 10.921 14.3697 10.7803 14.5181C10.6397 14.6666 10.4489 14.75 10.25 14.75H1.25C1.05109 14.75 0.860322 14.6666 0.71967 14.5181C0.579018 14.3697 0.5 14.1683 0.5 13.9583V2.08333C0.5 1.87337 0.579018 1.67201 0.71967 1.52354C0.860322 1.37507 1.05109 1.29167 1.25 1.29167H3.5M3.5 3.66667H8M3.5 7.625H8M3.5 10.7917H8M4.25 0.5V3.66667H7.25V0.5H4.25Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const intakeiconbig = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="22"
    viewBox="0 0 12 16"
    fill="none"
  >
    <path
      d="M8 1.29167H10.25C10.4489 1.29167 10.6397 1.37507 10.7803 1.52354C10.921 1.67201 11 1.87337 11 2.08333V13.9583C11 14.1683 10.921 14.3697 10.7803 14.5181C10.6397 14.6666 10.4489 14.75 10.25 14.75H1.25C1.05109 14.75 0.860322 14.6666 0.71967 14.5181C0.579018 14.3697 0.5 14.1683 0.5 13.9583V2.08333C0.5 1.87337 0.579018 1.67201 0.71967 1.52354C0.860322 1.37507 1.05109 1.29167 1.25 1.29167H3.5M3.5 3.66667H8M3.5 7.625H8M3.5 10.7917H8M4.25 0.5V3.66667H7.25V0.5H4.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const ChartIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.52 24.7125C3.96 24.7125 3.48333 24.5154 3.09 24.1213C2.69667 23.7279 2.5 23.2517 2.5 22.6925V8.84625H3.75V22.6925C3.75 22.9167 3.82208 23.1008 3.96625 23.245C4.11042 23.3892 4.295 23.4612 4.52 23.4612H23.75V24.7112L4.52 24.7125ZM8.27 20.9625C7.71 20.9625 7.23333 20.7654 6.84 20.3713C6.44667 19.9779 6.25 19.5017 6.25 18.9425V5.77C6.25 5.21 6.44667 4.73333 6.84 4.34C7.23333 3.94667 7.71 3.75 8.27 3.75H14.4712L16.9712 6.25H25.4812C26.0396 6.25 26.5158 6.44667 26.91 6.84C27.3033 7.23333 27.5 7.71 27.5 8.27V18.9425C27.5 19.5017 27.3033 19.9779 26.91 20.3713C26.5167 20.7646 26.04 20.9612 25.48 20.9612L8.27 20.9625ZM8.27 19.7125H25.4812C25.7054 19.7125 25.8896 19.64 26.0337 19.495C26.1779 19.3508 26.25 19.1667 26.25 18.9425V8.27C26.25 8.045 26.1779 7.86042 26.0337 7.71625C25.8896 7.57208 25.7054 7.5 25.4812 7.5H16.4687L13.9687 5H8.26875C8.04458 5 7.86042 5.07208 7.71625 5.21625C7.57208 5.36042 7.5 5.545 7.5 5.77V18.9425C7.5 19.1667 7.57208 19.3508 7.71625 19.495C7.86042 19.6392 8.045 19.7113 8.27 19.7113"
      fill="currentColor"
    />
  </svg>
);

export const OrderIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.224 19.1157H18.3074C18.1425 19.1157 18.004 19.0597 17.892 18.9477C17.78 18.8357 17.724 18.6968 17.724 18.5312C17.724 18.3655 17.78 18.2271 17.892 18.1158C18.004 18.0046 18.1425 17.9486 18.3074 17.9478H21.224V15.0312C21.224 14.8663 21.28 14.7278 21.392 14.6158C21.504 14.5038 21.6429 14.4478 21.8085 14.4478C21.9742 14.4478 22.1127 14.5038 22.2239 14.6158C22.3351 14.7278 22.3907 14.8663 22.3907 15.0312V17.9478H25.3074C25.473 17.9478 25.6119 18.0038 25.7239 18.1158C25.8359 18.2278 25.8915 18.3667 25.8907 18.5323C25.8899 18.698 25.8343 18.8364 25.7239 18.9477C25.6134 19.0589 25.4746 19.1149 25.3074 19.1157H22.3907V22.0323C22.3907 22.1972 22.3347 22.3357 22.2227 22.4477C22.1115 22.5589 21.973 22.6145 21.8074 22.6145C21.6417 22.6145 21.5033 22.5589 21.392 22.4477C21.2808 22.3364 21.2248 22.1976 21.224 22.0312V19.1157ZM3.99354 23.3332C3.45688 23.3332 3.00849 23.1535 2.64838 22.7942C2.28827 22.4348 2.1086 21.9864 2.10938 21.449V6.55067C2.10938 6.014 2.28904 5.566 2.64838 5.20667C3.00771 4.84734 3.4561 4.66728 3.99354 4.6665H18.8919C19.4285 4.6665 19.8765 4.84656 20.2359 5.20667C20.5952 5.56678 20.7753 6.01517 20.776 6.55184V11.0832C20.776 11.2488 20.72 11.3873 20.608 11.4985C20.496 11.6097 20.3572 11.6657 20.1915 11.6665C20.0259 11.6673 19.8874 11.6113 19.7762 11.4985C19.665 11.3857 19.6094 11.2473 19.6094 11.0832V8.6145H3.27604V21.4478C3.27604 21.6578 3.34332 21.8301 3.47788 21.9647C3.61243 22.0992 3.78432 22.1665 3.99354 22.1665H17.8594C18.0243 22.1665 18.1627 22.2225 18.2747 22.3345C18.3867 22.4465 18.4427 22.5853 18.4427 22.751C18.4427 22.9167 18.3867 23.0551 18.2747 23.1663C18.1627 23.2776 18.0243 23.3332 17.8594 23.3332H3.99354ZM3.27604 7.449H19.6094V6.55067C19.6094 6.34145 19.5417 6.16956 19.4064 6.035C19.2726 5.90045 19.1007 5.83317 18.8907 5.83317H3.99354C3.78354 5.83317 3.61166 5.90045 3.47788 6.035C3.34332 6.16956 3.27604 6.34184 3.27604 6.55184V7.449Z"
      fill="currentColor"
    />
  </svg>
);

export const NotesIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8054_14809)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.9482 3.77159C27.7973 3.20377 27.5133 2.68008 27.1197 2.24387C26.7261 1.80767 26.2342 1.47152 25.6848 1.26326C24.6475 0.810464 23.4787 0.760549 22.4065 1.12326C21.9674 1.30563 21.57 1.57557 21.2387 1.91659C20.7511 2.39675 20.3557 2.96221 20.072 3.58493C19.9115 3.89425 19.7938 4.22393 19.722 4.56493C19.696 4.66235 19.708 4.76602 19.7557 4.85488C19.8034 4.94373 19.8831 5.01109 19.9787 5.04326C20.0223 5.05995 20.0688 5.06775 20.1155 5.06618C20.1622 5.06462 20.208 5.05373 20.2504 5.03416C20.2928 5.0146 20.3309 4.98674 20.3624 4.95223C20.3938 4.91773 20.4181 4.87728 20.4337 4.83326L20.7953 3.98159C21.0313 3.55389 21.3258 3.16122 21.6703 2.81493C21.9839 2.52165 22.3644 2.30939 22.7787 2.19659C23.5682 2.0254 24.3925 2.13257 25.112 2.49993C25.4855 2.61442 25.8279 2.81266 26.1132 3.07954C26.3985 3.34641 26.6191 3.67489 26.7582 4.03993C26.9332 4.63959 26.9658 5.27076 26.8515 5.88326C26.7308 6.5033 26.5267 7.10414 26.2448 7.66943L26.0932 7.58776C24.8565 6.95776 21.9165 5.47609 21.017 4.97443C20.9224 4.92438 20.812 4.91346 20.7095 4.944C20.6069 4.97455 20.5205 5.04412 20.4687 5.13776C20.4186 5.23233 20.4077 5.34277 20.4383 5.44532C20.4688 5.54786 20.5384 5.63432 20.632 5.68609L25.812 8.50943C25.707 8.74276 25.532 9.09276 25.3103 9.52443C23.887 12.3489 20.4803 18.6979 19.267 20.8096C18.7753 20.3202 18.2446 19.8715 17.6803 19.4679C17.4003 19.2813 17.097 19.0946 16.8053 18.9313C16.4999 18.7699 16.1838 18.6295 15.8592 18.5113C15.2615 18.2904 14.6443 18.1264 14.0158 18.0213C14.0508 17.8766 14.0975 17.7366 14.1558 17.6013C15.2292 15.1151 18.0292 9.63059 19.3125 7.09776C19.6042 6.53776 19.8142 6.12943 19.9075 5.93109C20.1408 5.48776 19.4292 5.37109 19.4175 5.38276C19.1236 5.81164 18.866 6.26432 18.6475 6.73609C17.2358 9.29109 14.2025 14.6601 13.0475 17.1101C12.7792 17.5768 12.6042 18.0924 12.5342 18.6268C12.6158 19.1168 13.1292 22.5829 13.4675 23.9724C13.5282 24.3434 13.7032 24.6853 13.9692 24.9524C14.1803 25.0738 14.4242 25.1309 14.6692 25.1158C15.2076 25.049 15.7316 24.8953 16.2208 24.6608C17.5205 24.0588 18.7267 23.2729 19.8025 22.3274C20.0942 22.0008 23.607 15.2434 25.5332 11.2756C26.1048 10.1089 26.5365 9.18726 26.6998 8.74393C27.1253 7.8627 27.487 6.95621 27.7848 6.02443C27.9949 5.29333 28.0505 4.52535 27.9482 3.77159ZM14.9608 23.7391H14.7858C14.7858 23.7391 13.9925 19.8879 13.8058 18.8496C14.3542 19.1179 14.9725 19.4796 15.5675 19.8296C15.9292 20.0396 16.3142 20.2263 16.7342 20.4246C17.1542 20.6229 17.5158 20.7863 17.9008 20.9846L18.8108 21.5329C18.1505 22.0801 17.4342 22.5573 16.6758 22.9563C16.1333 23.2771 15.5582 23.5408 14.9608 23.7391Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0161 26.2706C13.3014 26.1176 12.5963 25.9229 11.9045 25.6872C11.4693 25.5403 11.0506 25.3488 10.655 25.1156C10.3257 24.9268 10.0829 24.6171 9.9783 24.2522C9.9465 23.7368 10.022 23.2204 10.2 22.7356C10.4378 22.0194 10.4378 21.2456 10.2 20.5294C10.0023 20.1206 9.67944 19.7855 9.2783 19.5727C8.78638 19.2977 8.24151 19.1307 7.67997 19.0827C6.67399 19.0654 5.66888 19.1514 4.68047 19.3394C3.21047 19.6381 1.7603 20.0277 0.339302 20.5061C0.249639 20.5109 0.164963 20.5489 0.101647 20.6125C0.0383311 20.6762 0.000874632 20.7611 -0.00347918 20.8508C-0.007833 20.9405 0.0212252 21.0286 0.078076 21.0981C0.134927 21.1676 0.215531 21.2136 0.304302 21.2271C0.350969 21.2325 0.397636 21.2294 0.444302 21.2177C1.61097 20.9727 2.77764 20.7277 4.0493 20.5644C5.20866 20.3961 6.38379 20.3647 7.55047 20.4711C7.8398 20.5026 8.1198 20.5854 8.3788 20.7161C8.5888 20.8211 8.81047 20.9261 8.88047 21.1011C9.02377 21.5567 9.02377 22.0454 8.88047 22.5011C8.68334 23.1798 8.65134 23.8958 8.78714 24.5894C8.88466 24.9127 9.04797 25.2124 9.26681 25.4695C9.48564 25.7267 9.75528 25.9359 10.0588 26.0839C10.5488 26.3297 11.0586 26.5202 11.5883 26.6556C12.335 26.8516 13.0894 27.0032 13.8516 27.1106C13.9566 27.1277 14.0642 27.1031 14.1513 27.0421C14.2385 26.981 14.2984 26.8884 14.3183 26.7839C14.334 26.7303 14.3385 26.674 14.3316 26.6185C14.3246 26.563 14.3064 26.5096 14.278 26.4615C14.2495 26.4133 14.2115 26.3716 14.1663 26.3387C14.121 26.3059 14.0695 26.2827 14.015 26.2706"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_8054_14809">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const threeDotIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PinIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 9.9165V12.8332"
      stroke="currentColor"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.91699 9.9165H11.0837V8.88984C11.0835 8.67279 11.0229 8.46007 10.9085 8.27561C10.7941 8.09115 10.6305 7.94226 10.4362 7.84567L9.39783 7.32067C9.20345 7.22408 9.03988 7.07519 8.92549 6.89073C8.8111 6.70627 8.75044 6.49355 8.75033 6.2765V3.49984H9.33366C9.64308 3.49984 9.93982 3.37692 10.1586 3.15813C10.3774 2.93934 10.5003 2.64259 10.5003 2.33317C10.5003 2.02375 10.3774 1.72701 10.1586 1.50821C9.93982 1.28942 9.64308 1.1665 9.33366 1.1665H4.66699C4.35757 1.1665 4.06083 1.28942 3.84203 1.50821C3.62324 1.72701 3.50033 2.02375 3.50033 2.33317C3.50033 2.64259 3.62324 2.93934 3.84203 3.15813C4.06083 3.37692 4.35757 3.49984 4.66699 3.49984H5.25033V6.2765C5.25021 6.49355 5.18955 6.70627 5.07516 6.89073C4.96078 7.07519 4.7972 7.22408 4.60283 7.32067L3.56449 7.84567C3.37012 7.94226 3.20654 8.09115 3.09216 8.27561C2.97777 8.46007 2.91711 8.67279 2.91699 8.88984V9.9165Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const PinIconFilled = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Pin needle (must stay STROKE) */}
    <path
      d="M7 9.9165V12.8332"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Pin body (FILLED) */}
    <path
      d="M2.91699 9.9165H11.0837V8.88984C11.0835 8.67279 11.0229 8.46007 10.9085 8.27561C10.7941 8.09115 10.6305 7.94226 10.4362 7.84567L9.39783 7.32067C9.20345 7.22408 9.03988 7.07519 8.92549 6.89073C8.8111 6.70627 8.75044 6.49355 8.75033 6.2765V3.49984H9.33366C9.64308 3.49984 9.93982 3.37692 10.1586 3.15813C10.3774 2.93934 10.5003 2.64259 10.5003 2.33317C10.5003 2.02375 10.3774 1.72701 10.1586 1.50821C9.93982 1.28942 9.64308 1.1665 9.33366 1.1665H4.66699C4.35757 1.1665 4.06083 1.28942 3.84203 1.50821C3.62324 1.72701 3.50033 2.02375 3.50033 2.33317C3.50033 2.64259 3.62324 2.93934 3.84203 3.15813C4.06083 3.37692 4.35757 3.49984 4.66699 3.49984H5.25033V6.2765C5.25021 6.49355 5.18955 6.70627 5.07516 6.89073C4.96078 7.07519 4.7972 7.22408 4.60283 7.32067L3.56449 7.84567C3.37012 7.94226 3.20654 8.09115 3.09216 8.27561C2.97777 8.46007 2.91711 8.67279 2.91699 8.88984V9.9165Z"
      fill="currentColor"
    />
  </svg>
);

export const listFileIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 2.5H9.5C8.94772 2.5 8.5 2.94772 8.5 3.5V5.5C8.5 6.05228 8.94772 6.5 9.5 6.5H15.5C16.0523 6.5 16.5 6.05228 16.5 5.5V3.5C16.5 2.94772 16.0523 2.5 15.5 2.5Z"
      stroke="#9CA3AF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5 4.5H18.5C19.0304 4.5 19.5391 4.71071 19.9142 5.08579C20.2893 5.46086 20.5 5.96957 20.5 6.5V20.5C20.5 21.0304 20.2893 21.5391 19.9142 21.9142C19.5391 22.2893 19.0304 22.5 18.5 22.5H6.5C5.96957 22.5 5.46086 22.2893 5.08579 21.9142C4.71071 21.5391 4.5 21.0304 4.5 20.5V6.5C4.5 5.96957 4.71071 5.46086 5.08579 5.08579C5.46086 4.71071 5.96957 4.5 6.5 4.5H8.5"
      stroke="#9CA3AF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 11.5H16.5"
      stroke="#9CA3AF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 16.5H16.5"
      stroke="#9CA3AF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 11.5H8.51"
      stroke="#9CA3AF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 16.5H8.51"
      stroke="#9CA3AF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const actionChartIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.41034 13.18C2.11167 13.18 1.85745 13.0749 1.64767 12.8647C1.4379 12.6549 1.33301 12.4009 1.33301 12.1027V4.718H1.99967V12.1027C1.99967 12.2222 2.03812 12.3204 2.11501 12.3973C2.1919 12.4742 2.29034 12.5127 2.41034 12.5127H12.6663V13.1793L2.41034 13.18ZM4.41034 11.18C4.11167 11.18 3.85745 11.0749 3.64767 10.8647C3.4379 10.6549 3.33301 10.4009 3.33301 10.1027V3.07733C3.33301 2.77867 3.4379 2.52444 3.64767 2.31467C3.85745 2.10489 4.11167 2 4.41034 2H7.71767L9.05101 3.33333H13.5897C13.8875 3.33333 14.1415 3.43822 14.3517 3.648C14.5615 3.85778 14.6663 4.112 14.6663 4.41067V10.1027C14.6663 10.4009 14.5615 10.6549 14.3517 10.8647C14.1419 11.0744 13.8877 11.1793 13.589 11.1793L4.41034 11.18ZM4.41034 10.5133H13.5897C13.7092 10.5133 13.8075 10.4747 13.8843 10.3973C13.9612 10.3204 13.9997 10.2222 13.9997 10.1027V4.41067C13.9997 4.29067 13.9612 4.19222 13.8843 4.11533C13.8075 4.03844 13.7092 4 13.5897 4H8.78301L7.44967 2.66667H4.40967C4.29012 2.66667 4.1919 2.70511 4.11501 2.782C4.03812 2.85889 3.99967 2.95733 3.99967 3.07733V10.1027C3.99967 10.2222 4.03812 10.3204 4.11501 10.3973C4.1919 10.4742 4.29034 10.5127 4.41034 10.5127"
      fill="currentColor"
    />
  </svg>
);

export const actionOrderIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1277 10.9232H10.4611C10.3669 10.9232 10.2877 10.8912 10.2237 10.8272C10.1597 10.7632 10.1277 10.6838 10.1277 10.5892C10.1277 10.4945 10.1597 10.4154 10.2237 10.3518C10.2877 10.2883 10.3669 10.2563 10.4611 10.2558H12.1277V8.58917C12.1277 8.49495 12.1597 8.41584 12.2237 8.35184C12.2877 8.28784 12.3671 8.25584 12.4617 8.25584C12.5564 8.25584 12.6355 8.28784 12.6991 8.35184C12.7626 8.41584 12.7944 8.49495 12.7944 8.58917V10.2558H14.4611C14.5557 10.2558 14.6351 10.2878 14.6991 10.3518C14.7631 10.4158 14.7949 10.4952 14.7944 10.5898C14.794 10.6845 14.7622 10.7636 14.6991 10.8272C14.636 10.8907 14.5566 10.9227 14.4611 10.9232H12.7944V12.5898C12.7944 12.6841 12.7624 12.7632 12.6984 12.8272C12.6349 12.8907 12.5557 12.9225 12.4611 12.9225C12.3664 12.9225 12.2873 12.8907 12.2237 12.8272C12.1602 12.7636 12.1282 12.6843 12.1277 12.5892V10.9232ZM2.28175 13.3332C1.97508 13.3332 1.71886 13.2305 1.51308 13.0252C1.3073 12.8198 1.20464 12.5636 1.20508 12.2565V3.74317C1.20508 3.4365 1.30775 3.1805 1.51308 2.97517C1.71841 2.76984 1.97464 2.66695 2.28175 2.6665H10.7951C11.1017 2.6665 11.3577 2.76939 11.5631 2.97517C11.7684 3.18095 11.8713 3.43717 11.8717 3.74384V6.33317C11.8717 6.42784 11.8397 6.50695 11.7757 6.5705C11.7117 6.63406 11.6324 6.66606 11.5377 6.6665C11.4431 6.66695 11.364 6.63495 11.3004 6.5705C11.2369 6.50606 11.2051 6.42695 11.2051 6.33317V4.9225H1.87175V12.2558C1.87175 12.3758 1.91019 12.4743 1.98708 12.5512C2.06397 12.6281 2.16219 12.6665 2.28175 12.6665H10.2051C10.2993 12.6665 10.3784 12.6985 10.4424 12.7625C10.5064 12.8265 10.5384 12.9058 10.5384 13.0005C10.5384 13.0952 10.5064 13.1743 10.4424 13.2378C10.3784 13.3014 10.2993 13.3332 10.2051 13.3332H2.28175ZM1.87175 4.2565H11.2051V3.74317C11.2051 3.62361 11.1664 3.52539 11.0891 3.4485C11.0126 3.37161 10.9144 3.33317 10.7944 3.33317H2.28175C2.16175 3.33317 2.06352 3.37161 1.98708 3.4485C1.91019 3.52539 1.87175 3.62384 1.87175 3.74384V4.2565Z"
      fill="currentColor"
    />
  </svg>
);

export const actionNotesIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8130_5311)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9711 2.15534C15.8849 1.83087 15.7226 1.53161 15.4977 1.28235C15.2727 1.0331 14.9917 0.841009 14.6778 0.722003C14.085 0.463262 13.4171 0.434739 12.8044 0.642003C12.5535 0.746215 12.3264 0.900464 12.1371 1.09534C11.8585 1.36971 11.6325 1.69283 11.4704 2.04867C11.3787 2.22542 11.3114 2.41381 11.2704 2.60867C11.2555 2.66434 11.2624 2.72358 11.2897 2.77435C11.3169 2.82513 11.3625 2.86362 11.4171 2.882C11.442 2.89154 11.4686 2.89599 11.4953 2.8951C11.5219 2.89421 11.5482 2.88799 11.5724 2.87681C11.5966 2.86562 11.6184 2.8497 11.6363 2.82999C11.6543 2.81027 11.6682 2.78716 11.6771 2.762L11.8838 2.27534C12.0186 2.03094 12.1869 1.80655 12.3838 1.60867C12.5629 1.44108 12.7804 1.31979 13.0171 1.25534C13.4682 1.15751 13.9393 1.21875 14.3504 1.42867C14.5638 1.4941 14.7595 1.60737 14.9225 1.75988C15.0855 1.91238 15.2116 2.10007 15.2911 2.30867C15.3911 2.65134 15.4098 3.012 15.3444 3.362C15.2754 3.71631 15.1588 4.05965 14.9978 4.38267L14.9111 4.336C14.2044 3.976 12.5244 3.12934 12.0104 2.84267C11.9564 2.81407 11.8933 2.80783 11.8347 2.82528C11.7761 2.84274 11.7267 2.8825 11.6971 2.936C11.6685 2.99004 11.6622 3.05315 11.6797 3.11175C11.6972 3.17035 11.7369 3.21975 11.7904 3.24934L14.7504 4.86267C14.6904 4.996 14.5904 5.196 14.4638 5.44267C13.6504 7.05667 11.7038 10.6847 11.0104 11.8913C10.7294 11.6117 10.4262 11.3553 10.1038 11.1247C9.94375 11.018 9.77042 10.9113 9.60375 10.818C9.42921 10.7258 9.24856 10.6456 9.06309 10.578C8.72154 10.4518 8.36887 10.3581 8.00975 10.298C8.02975 10.2153 8.05642 10.1353 8.08975 10.058C8.70309 8.63734 10.3031 5.50334 11.0364 4.056C11.2031 3.736 11.3231 3.50267 11.3764 3.38934C11.5098 3.136 11.1031 3.06934 11.0964 3.076C10.9285 3.32108 10.7813 3.57975 10.6564 3.84934C9.84975 5.30934 8.11642 8.37734 7.45642 9.77734C7.30309 10.044 7.20309 10.3387 7.16309 10.644C7.20975 10.924 7.50309 12.9047 7.69642 13.6987C7.73109 13.9107 7.83109 14.106 7.98309 14.2587C8.10375 14.328 8.24309 14.3607 8.38309 14.352C8.69076 14.3139 8.9902 14.226 9.26975 14.092C10.0124 13.748 10.7017 13.299 11.3164 12.7587C11.4831 12.572 13.4904 8.71067 14.5911 6.44334C14.9178 5.77667 15.1644 5.25 15.2578 4.99667C15.5009 4.49311 15.7075 3.97511 15.8778 3.44267C15.9978 3.0249 16.0296 2.58606 15.9711 2.15534ZM8.54975 13.5653H8.44975C8.44975 13.5653 7.99642 11.3647 7.88975 10.7713C8.20309 10.9247 8.55642 11.1313 8.89642 11.3313C9.10309 11.4513 9.32309 11.558 9.56309 11.6713C9.80309 11.7847 10.0098 11.878 10.2298 11.9913L10.7498 12.3047C10.3724 12.6173 9.96309 12.89 9.52975 13.118C9.21975 13.3013 8.89109 13.452 8.54975 13.5653Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0095 15.0119C7.6011 14.9245 7.19818 14.8132 6.80283 14.6786C6.55419 14.5946 6.31491 14.4851 6.08883 14.3519C5.90065 14.244 5.76194 14.0671 5.70217 13.8586C5.68399 13.564 5.72712 13.2689 5.82883 12.9919C5.96474 12.5827 5.96474 12.1405 5.82883 11.7312C5.71588 11.4976 5.53139 11.3061 5.30217 11.1846C5.02107 11.0274 4.70971 10.932 4.38883 10.9046C3.81399 10.8947 3.23964 10.9438 2.67483 11.0512C1.83483 11.2219 1.00617 11.4446 0.194166 11.7179C0.14293 11.7207 0.0945434 11.7423 0.058363 11.7787C0.0221825 11.8151 0.000778807 11.8636 -0.00170909 11.9149C-0.00419698 11.9661 0.0124077 12.0165 0.0448939 12.0562C0.0773801 12.0959 0.12344 12.1222 0.174166 12.1299C0.200833 12.133 0.227499 12.1312 0.254166 12.1246C0.920833 11.9846 1.5875 11.8446 2.31417 11.7512C2.97665 11.655 3.64816 11.6371 4.31483 11.6979C4.48017 11.7159 4.64017 11.7632 4.78817 11.8379C4.90817 11.8979 5.03483 11.9579 5.07483 12.0579C5.15672 12.3183 5.15672 12.5975 5.07483 12.8579C4.96219 13.2457 4.9439 13.6549 5.0215 14.0512C5.07723 14.236 5.17055 14.4072 5.2956 14.5542C5.42065 14.7011 5.57473 14.8206 5.74817 14.9052C6.02817 15.0457 6.3195 15.1546 6.62217 15.2319C7.04883 15.3439 7.47994 15.4306 7.9155 15.4919C7.97551 15.5017 8.03695 15.4876 8.08676 15.4527C8.13656 15.4179 8.1708 15.365 8.18217 15.3052C8.19114 15.2746 8.19372 15.2424 8.18976 15.2107C8.18579 15.179 8.17536 15.1485 8.15911 15.121C8.14286 15.0935 8.12114 15.0696 8.09529 15.0508C8.06944 15.0321 8.04001 15.0188 8.00883 15.0119"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_8130_5311">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const actionDollarIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.3335V14.6668"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3333 3.3335H6.33333C5.71449 3.3335 5.121 3.57933 4.68342 4.01691C4.24583 4.4545 4 5.04799 4 5.66683C4 6.28567 4.24583 6.87916 4.68342 7.31675C5.121 7.75433 5.71449 8.00016 6.33333 8.00016H9.66667C10.2855 8.00016 10.879 8.246 11.3166 8.68358C11.7542 9.12117 12 9.71466 12 10.3335C12 10.9523 11.7542 11.5458 11.3166 11.9834C10.879 12.421 10.2855 12.6668 9.66667 12.6668H4"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const actionDollarIconbig = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.3335V14.6668"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3333 3.3335H6.33333C5.71449 3.3335 5.121 3.57933 4.68342 4.01691C4.24583 4.4545 4 5.04799 4 5.66683C4 6.28567 4.24583 6.87916 4.68342 7.31675C5.121 7.75433 5.71449 8.00016 6.33333 8.00016H9.66667C10.2855 8.00016 10.879 8.246 11.3166 8.68358C11.7542 9.12117 12 9.71466 12 10.3335C12 10.9523 11.7542 11.5458 11.3166 11.9834C10.879 12.421 10.2855 12.6668 9.66667 12.6668H4"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const actionDropDownCalenderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M5.30664 1.41666V3.75"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.97339 1.41666V3.75"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7233 2.58334H3.55668C2.91235 2.58334 2.39001 3.10567 2.39001 3.75V11.9167C2.39001 12.561 2.91235 13.0833 3.55668 13.0833H11.7233C12.3677 13.0833 12.89 12.561 12.89 11.9167V3.75C12.89 3.10567 12.3677 2.58334 11.7233 2.58334Z"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.39001 6.08334H12.89"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const actionDropDownCalenderIconbig = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M5.30664 1.41666V3.75"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.97339 1.41666V3.75"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7233 2.58334H3.55668C2.91235 2.58334 2.39001 3.10567 2.39001 3.75V11.9167C2.39001 12.561 2.91235 13.0833 3.55668 13.0833H11.7233C12.3677 13.0833 12.89 12.561 12.89 11.9167V3.75C12.89 3.10567 12.3677 2.58334 11.7233 2.58334Z"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.39001 6.08334H12.89"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const actionDropDownChatIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4165 4.03809H8.83008C8.28307 4.03809 7.75846 4.25538 7.37167 4.64218C6.98488 5.02897 6.76758 5.55358 6.76758 6.10059V12.1708C6.76758 12.7178 6.98488 13.2424 7.37167 13.6292C7.75846 14.016 8.28307 14.2333 8.83008 14.2333H11.7116L16.0901 16.2155V14.2337H17.4165C17.9635 14.2337 18.4881 14.0164 18.8749 13.6296C19.2617 13.2428 19.479 12.7182 19.479 12.1712V6.10059C19.479 5.55358 19.2617 5.02897 18.8749 4.64218C18.4881 4.25538 17.9635 4.03809 17.4165 4.03809Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.0776 14.2846V15.1527C11.0776 15.9594 10.4268 16.6102 9.62467 16.6102H7.75467L4.84426 17.9623V16.6102H3.97342C3.17134 16.6102 2.52051 15.9594 2.52051 15.1527V11.156C2.52051 10.354 3.17134 9.70312 3.97342 9.70312H6.68676"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const actionDropDownSchedulerIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 9C1.5 6.17175 1.5 4.75725 2.379 3.879C3.258 3.00075 4.67175 3 7.5 3H10.5C13.3282 3 14.7427 3 15.621 3.879C16.4992 4.758 16.5 6.17175 16.5 9V10.5C16.5 13.3282 16.5 14.7427 15.621 15.621C14.742 16.4992 13.3282 16.5 10.5 16.5H7.5C4.67175 16.5 3.25725 16.5 2.379 15.621C1.50075 14.742 1.5 13.3282 1.5 10.5V9Z"
      stroke="CurrentColor"
    />
    <path
      d="M5.25 3V1.875M12.75 3V1.875M1.875 6.75H16.125"
      stroke="CurrentColor"
      stroke-linecap="round"
    />
    <path
      d="M13.5 12.75C13.5 12.9489 13.421 13.1397 13.2803 13.2803C13.1397 13.421 12.9489 13.5 12.75 13.5C12.5511 13.5 12.3603 13.421 12.2197 13.2803C12.079 13.1397 12 12.9489 12 12.75C12 12.5511 12.079 12.3603 12.2197 12.2197C12.3603 12.079 12.5511 12 12.75 12C12.9489 12 13.1397 12.079 13.2803 12.2197C13.421 12.3603 13.5 12.5511 13.5 12.75ZM13.5 9.75C13.5 9.94891 13.421 10.1397 13.2803 10.2803C13.1397 10.421 12.9489 10.5 12.75 10.5C12.5511 10.5 12.3603 10.421 12.2197 10.2803C12.079 10.1397 12 9.94891 12 9.75C12 9.55109 12.079 9.36032 12.2197 9.21967C12.3603 9.07902 12.5511 9 12.75 9C12.9489 9 13.1397 9.07902 13.2803 9.21967C13.421 9.36032 13.5 9.55109 13.5 9.75ZM9.75 12.75C9.75 12.9489 9.67098 13.1397 9.53033 13.2803C9.38968 13.421 9.19891 13.5 9 13.5C8.80109 13.5 8.61032 13.421 8.46967 13.2803C8.32902 13.1397 8.25 12.9489 8.25 12.75C8.25 12.5511 8.32902 12.3603 8.46967 12.2197C8.61032 12.079 8.80109 12 9 12C9.19891 12 9.38968 12.079 9.53033 12.2197C9.67098 12.3603 9.75 12.5511 9.75 12.75ZM9.75 9.75C9.75 9.94891 9.67098 10.1397 9.53033 10.2803C9.38968 10.421 9.19891 10.5 9 10.5C8.80109 10.5 8.61032 10.421 8.46967 10.2803C8.32902 10.1397 8.25 9.94891 8.25 9.75C8.25 9.55109 8.32902 9.36032 8.46967 9.21967C8.61032 9.07902 8.80109 9 9 9C9.19891 9 9.38968 9.07902 9.53033 9.21967C9.67098 9.36032 9.75 9.55109 9.75 9.75ZM6 12.75C6 12.9489 5.92098 13.1397 5.78033 13.2803C5.63968 13.421 5.44891 13.5 5.25 13.5C5.05109 13.5 4.86032 13.421 4.71967 13.2803C4.57902 13.1397 4.5 12.9489 4.5 12.75C4.5 12.5511 4.57902 12.3603 4.71967 12.2197C4.86032 12.079 5.05109 12 5.25 12C5.44891 12 5.63968 12.079 5.78033 12.2197C5.92098 12.3603 6 12.5511 6 12.75ZM6 9.75C6 9.94891 5.92098 10.1397 5.78033 10.2803C5.63968 10.421 5.44891 10.5 5.25 10.5C5.05109 10.5 4.86032 10.421 4.71967 10.2803C4.57902 10.1397 4.5 9.94891 4.5 9.75C4.5 9.55109 4.57902 9.36032 4.71967 9.21967C4.86032 9.07902 5.05109 9 5.25 9C5.44891 9 5.63968 9.07902 5.78033 9.21967C5.92098 9.36032 6 9.55109 6 9.75Z"
      fill="CurrentColor"
    />
  </svg>
);

export const actionDropDownSchedulerIconBig = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 9C1.5 6.17175 1.5 4.75725 2.379 3.879C3.258 3.00075 4.67175 3 7.5 3H10.5C13.3282 3 14.7427 3 15.621 3.879C16.4992 4.758 16.5 6.17175 16.5 9V10.5C16.5 13.3282 16.5 14.7427 15.621 15.621C14.742 16.4992 13.3282 16.5 10.5 16.5H7.5C4.67175 16.5 3.25725 16.5 2.379 15.621C1.50075 14.742 1.5 13.3282 1.5 10.5V9Z"
      stroke="CurrentColor"
    />
    <path
      d="M5.25 3V1.875M12.75 3V1.875M1.875 6.75H16.125"
      stroke="CurrentColor"
      strokeLinecap="round"
    />
    <path
      d="M13.5 12.75C13.5 12.9489 13.421 13.1397 13.2803 13.2803C13.1397 13.421 12.9489 13.5 12.75 13.5C12.5511 13.5 12.3603 13.421 12.2197 13.2803C12.079 13.1397 12 12.9489 12 12.75C12 12.5511 12.079 12.3603 12.2197 12.2197C12.3603 12.079 12.5511 12 12.75 12C12.9489 12 13.1397 12.079 13.2803 12.2197C13.421 12.3603 13.5 12.5511 13.5 12.75ZM13.5 9.75C13.5 9.94891 13.421 10.1397 13.2803 10.2803C13.1397 10.421 12.9489 10.5 12.75 10.5C12.5511 10.5 12.3603 10.421 12.2197 10.2803C12.079 10.1397 12 9.94891 12 9.75C12 9.55109 12.079 9.36032 12.2197 9.21967C12.3603 9.07902 12.5511 9 12.75 9C12.9489 9 13.1397 9.07902 13.2803 9.21967C13.421 9.36032 13.5 9.55109 13.5 9.75ZM9.75 12.75C9.75 12.9489 9.67098 13.1397 9.53033 13.2803C9.38968 13.421 9.19891 13.5 9 13.5C8.80109 13.5 8.61032 13.421 8.46967 13.2803C8.32902 13.1397 8.25 12.9489 8.25 12.75C8.25 12.5511 8.32902 12.3603 8.46967 12.2197C8.61032 12.079 8.80109 12 9 12C9.19891 12 9.38968 12.079 9.53033 12.2197C9.67098 12.3603 9.75 12.5511 9.75 12.75ZM9.75 9.75C9.75 9.94891 9.67098 10.1397 9.53033 10.2803C9.38968 10.421 9.19891 10.5 9 10.5C8.80109 10.5 8.61032 10.421 8.46967 10.2803C8.32902 10.1397 8.25 9.94891 8.25 9.75C8.25 9.55109 8.32902 9.36032 8.46967 9.21967C8.61032 9.07902 8.80109 9 9 9C9.19891 9 9.38968 9.07902 9.53033 9.21967C9.67098 9.36032 9.75 9.55109 9.75 9.75ZM6 12.75C6 12.9489 5.92098 13.1397 5.78033 13.2803C5.63968 13.421 5.44891 13.5 5.25 13.5C5.05109 13.5 4.86032 13.421 4.71967 13.2803C4.57902 13.1397 4.5 12.9489 4.5 12.75C4.5 12.5511 4.57902 12.3603 4.71967 12.2197C4.86032 12.079 5.05109 12 5.25 12C5.44891 12 5.63968 12.079 5.78033 12.2197C5.92098 12.3603 6 12.5511 6 12.75ZM6 9.75C6 9.94891 5.92098 10.1397 5.78033 10.2803C5.63968 10.421 5.44891 10.5 5.25 10.5C5.05109 10.5 4.86032 10.421 4.71967 10.2803C4.57902 10.1397 4.5 9.94891 4.5 9.75C4.5 9.55109 4.57902 9.36032 4.71967 9.21967C4.86032 9.07902 5.05109 9 5.25 9C5.44891 9 5.63968 9.07902 5.78033 9.21967C5.92098 9.36032 6 9.55109 6 9.75Z"
      fill="CurrentColor"
    />
  </svg>
);

const Roomicon=<svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
  <path d="M0 18V16.875H2.25V0H11.25V1.125H14.625V16.875H16.875V18H13.5V2.25H11.25V18H0ZM8.4825 9.6075C8.655 9.435 8.74125 9.2325 8.74125 9C8.74125 8.7675 8.655 8.565 8.4825 8.3925C8.31 8.22 8.1075 8.13375 7.875 8.13375C7.6425 8.13375 7.44 8.22 7.2675 8.3925C7.095 8.565 7.00875 8.7675 7.00875 9C7.00875 9.2325 7.095 9.435 7.2675 9.6075C7.44 9.78 7.6425 9.86625 7.875 9.86625C8.1075 9.86625 8.31 9.78 8.4825 9.6075Z" fill="white"/>
</svg>
export const actionDropDownChatIconBig = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.4997 6.60742H14.4492C13.5541 6.60742 12.6957 6.963 12.0627 7.59594C11.4298 8.22887 11.0742 9.08732 11.0742 9.98242V19.9154C11.0742 20.8105 11.4298 21.669 12.0627 22.3019C12.6957 22.9348 13.5541 23.2904 14.4492 23.2904H19.1645L26.3292 26.5342V23.2912H28.4997C29.3948 23.2912 30.2533 22.9356 30.8862 22.3027C31.5191 21.6697 31.8747 20.8113 31.8747 19.9162V9.98242C31.8747 9.08732 31.5191 8.22887 30.8862 7.59594C30.2533 6.963 29.3948 6.60742 28.4997 6.60742Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.1275 23.3744V24.7949C18.1275 26.1149 17.0625 27.1799 15.75 27.1799H12.69L7.9275 29.3924V27.1799H6.5025C5.19 27.1799 4.125 26.1149 4.125 24.7949V18.2549C4.125 16.9424 5.19 15.8774 6.5025 15.8774H10.9425"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const RoomBadge = ({ roomNo }) => {
  const isText = !!roomNo;

  const fontSize =
    roomNo === "Waiting Room" ? "9px" : isText ? "25px" : "9px";

  if (isText) {
    return (
      <div
        style={{
          display: "flex",
          width: "42px",
          height: "39px",
          padding: "2px 8px",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "Inter, sans-serif",
          fontWeight: 400,
          fontSize: fontSize,
          textAlign: "center",
          color: "#50869A",
        }}
      >
        {roomNo}
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        width: "42px",
        height: "39px",
        padding: "2px 8px",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        borderRadius: "8px",
        border: "1px solid rgba(0,0,0,0)",
        background: "#1D2951",
        color: "rgba(255,255,255,0.90)",
        fontFamily: "Inter, sans-serif",
        fontWeight: 400,
        fontSize: fontSize,
        textAlign: "center",
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
  <path d="M0 18V16.875H2.25V0H11.25V1.125H14.625V16.875H16.875V18H13.5V2.25H11.25V18H0ZM8.4825 9.6075C8.655 9.435 8.74125 9.2325 8.74125 9C8.74125 8.7675 8.655 8.565 8.4825 8.3925C8.31 8.22 8.1075 8.13375 7.875 8.13375C7.6425 8.13375 7.44 8.22 7.2675 8.3925C7.095 8.565 7.00875 8.7675 7.00875 9C7.00875 9.2325 7.095 9.435 7.2675 9.6075C7.44 9.78 7.6425 9.86625 7.875 9.86625C8.1075 9.86625 8.31 9.78 8.4825 9.6075Z" fill="white"/>
</svg>
    </div>
  );
};
// export const RoomBadge = ({ roomNo, width = 34, height = 41 }) => {
//   return (
//     <svg
//       className="pointer-events-none block"
//       xmlns="http://www.w3.org/2000/svg"
//       width={width}
//       height={height}
//       viewBox="0 0 42 54"
//       fill="none"
//     >
//       <path
//         d="M4.66667 -1C1.62089 -1 0 1.61094 0 3.77075V48.9124C0 52.7245 4.57022 55.4201 8.35644 53.1926L20.6298 45.9716C20.7387 45.9037 20.8678 45.8674 21 45.8674C21.1322 45.8674 21.2613 45.9037 21.3702 45.9716L33.6436 53.1926C37.4298 55.4201 42 52.7273 42 48.9124V3.77075C42 1.61094 40.3791 -1 37.3333 -1H4.66667Z"
//         fill="#1D2951"
//       />

//       <foreignObject x="0" y="0" width="42" height="46">
//         <div
//           xmlns="http://www.w3.org/1999/xhtml"
//           className="pointer-events-none flex items-center justify-center w-full h-full text-white font-semibold text-center"
//           style={{
//             color: "rgba(255,255,255,0.90)",
//           fontSize: roomNo === "Waiting Room" ? "9px" : roomNo ? "20px" : "9px",
//             fontFamily: "Inter, sans-serif",
//             padding: "2px",
//             fontWeight:"400"

//           }}
//         >
//           {roomNo || "Assign Room"}
//         </div>
//       </foreignObject>
//     </svg>
//   );
// };
export const RpmIcon = ({ data, latestRpm, color = "#14A94B" }) => {
  return (
    <div className="relative inline-block">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
        <path d="M0.599609 4.6001H3.04405L4.87739 8.6001L7.32183 0.600098L9.15516 4.6001H11.5996" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>

      {/* Tooltip */}
      {latestRpm && (
        <div
          className="absolute left-1/2 -translate-x-1/2 top-full mt-2 
          bg-[#1D2951] text-white text-xs font-medium 
          py-1.5 px-3 rounded-md opacity-0 group-hover:opacity-100 
          pointer-events-none transition-all duration-200 
          whitespace-nowrap shadow-md z-50"
        >
          <div>BP: {latestRpm.bp}</div>
          <div>{dayjs(latestRpm.datetime).format("MM-DD-YYYY hh:mm A")}</div>
        </div>
      )}
    </div>
  );
};

export const mobileiconnew = (
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M9.33333 1.1665H4.66667C4.02233 1.1665 3.5 1.68884 3.5 2.33317V11.6665C3.5 12.3108 4.02233 12.8332 4.66667 12.8332H9.33333C9.97767 12.8332 10.5 12.3108 10.5 11.6665V2.33317C10.5 1.68884 9.97767 1.1665 9.33333 1.1665Z" stroke="#055CB4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.9707 10.5H7.02904" stroke="#055CB4" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);